import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LOGIN_TOKEN } from "../ApiSetUp/AuthApi";
import localStoreUtil from "../ApiSetUp/localstore.util";

export const ProtectedRoutes = () => {
  const loginToken = localStoreUtil.get_data(LOGIN_TOKEN);

  if (!loginToken) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};